"use client";

import { c as _c } from "react/compiler-runtime";
import type { KeyboardEvent, MouseEvent } from "react";
import type { LinkProps } from "@/components/Link/Link.component";
import { RegularLink } from "@/components/Link/RegularLink.component";
import { useJpmuid } from "@/hooks/tracking/jpmuid/use-jpmuid.hook";
import { useTracking } from "@/hooks/tracking/use-tracking";
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
import type { SnowplowClickTrackingModel } from "@/vendors/Snowplow/models/snowplow-click-tracking.model.types";
type SnowplowLinkProps = LinkProps & {
  readonly trackingModel: Omit<SnowplowClickTrackingModel, "classes" | "consent" | "user" | "jpmuid" | "url">;
};
export function SnowplowLink(t0) {
  const $ = _c(24);
  let children;
  let className;
  let href;
  let rest;
  let trackingModel;
  if ($[0] !== t0) {
    ({
      children,
      className,
      href,
      trackingModel,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = href;
    $[4] = rest;
    $[5] = trackingModel;
  } else {
    children = $[1];
    className = $[2];
    href = $[3];
    rest = $[4];
    trackingModel = $[5];
  }
  const {
    emit
  } = useTracking();
  const {
    user
  } = useAuthentication();
  const consent = useCookiebotConsent();
  const {
    jpmuid
  } = useJpmuid();
  let t1;
  if ($[6] !== consent || $[7] !== emit || $[8] !== href || $[9] !== jpmuid || $[10] !== trackingModel || $[11] !== user) {
    t1 = () => {
      emit({
        event: "link-click",
        model: {
          classes: [],
          consent,
          jpmuid,
          url: href,
          user,
          ...trackingModel
        }
      });
    };
    $[6] = consent;
    $[7] = emit;
    $[8] = href;
    $[9] = jpmuid;
    $[10] = trackingModel;
    $[11] = user;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  const trackClick = t1;
  let t2;
  if ($[13] !== trackClick) {
    t2 = event => {
      if (event.button !== 2) {
        trackClick();
      }
    };
    $[13] = trackClick;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const handleMouseDown = t2;
  let t3;
  if ($[15] !== trackClick) {
    t3 = event_0 => {
      if (event_0.key === "Enter") {
        trackClick();
      }
    };
    $[15] = trackClick;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const handleKeyDown = t3;
  let t4;
  if ($[17] !== children || $[18] !== className || $[19] !== handleKeyDown || $[20] !== handleMouseDown || $[21] !== href || $[22] !== rest) {
    t4 = <RegularLink className={className} href={href} {...rest} onKeyDown={handleKeyDown} onMouseDown={handleMouseDown}>{children}</RegularLink>;
    $[17] = children;
    $[18] = className;
    $[19] = handleKeyDown;
    $[20] = handleMouseDown;
    $[21] = href;
    $[22] = rest;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
}